import { graphql } from '../../../../graphql/generated';

export const UPDATE_SPECIMEN_MUTATION = graphql(`
  mutation UpdateSpecimen($id: ID!, $input: SpecimenUpdateInput!) {
    updateSpecimen(id: $id, input: $input) {
      id
    }
  }
`);
